var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "dropper",
        clickToClose: true,
        resizable: false,
        scrollable: false,
        reset: true,
        height: _vm.modalHeight,
        width: _vm.modalWidth,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "centeringparent",
          staticStyle: { height: "100%", width: "100%" },
          on: {
            drop: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.onDrop.apply(null, arguments)
            },
            dragover: function ($event) {
              $event.preventDefault()
              return _vm.onDragOver.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c("progress-bar", {
                attrs: { size: "tiny", val: _vm.prgCur, max: _vm.prgTotal },
              }),
            ],
            1
          ),
          _vm.selectedProject == undefined
            ? _c("div", { staticClass: "centeringparent" }, [
                _c(
                  "div",
                  {
                    staticClass: "centeringparent",
                    staticStyle: {
                      "max-width": "60%",
                      "max-height": "60%",
                      width: "60%",
                      height: "60%",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "smallerpreview",
                      attrs: { src: require("./../assets/worn_forbidden.png") },
                    }),
                    _c("p", { staticClass: "standardtext" }, [
                      _vm._v("Select a project first"),
                    ]),
                  ]
                ),
              ])
            : _c("div", { staticClass: "centeringparent picframe" }, [
                _c("img", {
                  staticClass: "thumbnailpreview",
                  attrs: { src: _vm.currentImg },
                }),
              ]),
          _vm.showingImg > 0
            ? _c("div", { staticStyle: { height: "15px" } }, [
                _c("p", { staticClass: "standardtext" }, [
                  _vm._v(_vm._s(_vm.doneFiles) + "/" + _vm._s(_vm.totFiles)),
                ]),
              ])
            : _c("div", { staticStyle: { height: "15px" } }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }